import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { deleteParamsFromUrl, getUrlParam } from 'core-components/helpers/url'
import { useNavigate } from 'core/hooks/useNavigate'
import { MANAGER_COCKPIT_PAGE_URL } from 'partner360/configs'

import { SECTION_URL_PARAM } from './config'

export const useClearManagerCockpitTab = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const clearSectionOutsideCockpit = () => {
      const { pathname: destinationPathname } = window.location
      if (
        getUrlParam('page', destinationPathname) === MANAGER_COCKPIT_PAGE_URL ||
        !getUrlParam(SECTION_URL_PARAM, destinationPathname)
      ) {
        return
      }

      navigate(deleteParamsFromUrl([SECTION_URL_PARAM]), { replace: true })
    }

    clearSectionOutsideCockpit()
    return clearSectionOutsideCockpit
  }, [navigate, pathname])
}
